export const CITIES_API_URL = 'https://geo.api.gouv.fr/communes'
export const STALE_TIME_CITIES = 5 * 60 * 1000
export const STALE_TIME_COUNTRIES = 24 * 60 * 1000
